"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SiteMenu = exports.IconSite = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("@lingui/react");

var _core = require("@lingui/core");

var _react2 = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _selections = require("../../redux/modules/_BETA/selections");

var _FilterList = _interopRequireDefault(require("./components/FilterList"));

var _blocks = require("@bueno/blocks");

var _Menu = _interopRequireDefault(require("../../components/Menu"));

var _Loading = _interopRequireDefault(require("../../components/Loading"));

var _MenuFooter = _interopRequireDefault(require("./components/MenuFooter"));

var _SelectedSites = require("./components/SelectedSites");

var _Projects = _interopRequireDefault(require("./components/Projects"));

var _Sites = _interopRequireDefault(require("./components/Sites"));

var _utils = require("./utils");

var _SiteMenu = require("./SiteMenu.styles");

var _eventTracking = require("../../utils/eventTracking");

var _SiteMenuAvatar = require("./components/SiteMenuAvatar");

function mapStateToProps({
  userSites,
  betaSelections,
  auth
}) {
  const {
    sites,
    projects,
    projectGroups,
    hasLoaded,
    isLoading
  } = userSites;
  const {
    activeProject,
    activeSite,
    selectedSites,
    isMultiSite
  } = betaSelections;
  return {
    activeProject,
    activeSite,
    selectedSites,
    loggedIn: auth.user.username !== undefined,
    isMultiSite,
    sites,
    projects,
    projectGroups,
    hasLoaded,
    isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectProject: projectId => () => dispatch((0, _selections.selectActiveProject)(projectId)),
    selectSites: sites => dispatch((0, _selections.updateSelectedSites)(sites))
  };
}

const IconSite = () => {
  return /*#__PURE__*/_react2.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react2.default.createElement("path", {
    d: "M9 16.001V14.001H7V16.001H9Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M13 6H11V8H13V6Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M17 6H15V8H17V6Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M17 10.031H15V12H17V10.031Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M17 14H15V16H17V14Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2H19C20.103 2 21 2.897 21 4V21C21 21.552 20.553 22 20 22H4C3.447 22 3 21.552 3 21V12C3 10.897 3.897 10 5 10H7V4C7 2.897 7.897 2 9 2ZM5 12V20H11V12H5ZM13 20H19V4H9V10H11C12.103 10 13 10.897 13 12V20Z",
    fill: "#FBFCFD"
  }));
};

exports.IconSite = IconSite;

class SiteMenu extends _react2.default.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleActiveProjectChange", () => {
      this.setState((0, _utils.projectChangeSetState)(this.props.activeProject.sites));
    });
    (0, _defineProperty2.default)(this, "handleSiteSelect", site => () => {
      this.setState(state => {
        const clone = new Set(state.selectedSites);
        const isSelected = clone.has(site.syncoId);

        if (isSelected) {
          clone.delete(site.syncoId);
        } else {
          clone.add(site.syncoId);
        }

        const sites = state.shouldFilter && state.matchingSites.size !== 0 ? this.props.activeProject.sites.filter(site => state.matchingSites.has(site.syncoId)) : this.props.activeProject.sites;
        const isAllSelected = (0, _utils.calcIsAllSelected)(sites, clone);
        const currentlyActive = new Set(this.props.selectedSites);
        const isPristine = (0, _utils.eqSet)(clone, currentlyActive);
        return {
          isAllSelected,
          selectedSites: clone,
          isPristine
        };
      });
    });
    (0, _defineProperty2.default)(this, "handleSelectAll", () => {
      this.setState((0, _utils.selectAllSetState)(this.props.activeProject.sites, this.props.selectedSites));
    });
    (0, _defineProperty2.default)(this, "handleFilter", ({
      filteredData,
      searchString
    }) =>
    /* TODO: Fix the type */
    {
      const matchingProjects = new Set(filteredData.map(site => site.projectId));
      const matchingSites = new Set(filteredData.map(site => site.syncoId));
      this.setState({
        shouldFilter: searchString !== '',
        matchingProjects,
        matchingSites
      });
    });
    (0, _defineProperty2.default)(this, "handleClearAll", () => {
      this.setState({
        selectedSites: new Set(),
        isAllSelected: false
      });
    });
    (0, _defineProperty2.default)(this, "handleConfirmSelectedSites", cb => () => {
      const selected = Array.from(this.state.selectedSites);
      const {
        sites,
        projects
      } = this.props; // Track selected sites + projects

      (0, _eventTracking.siteSelectEvent)(selected, sites, projects); // Set selected in state and url

      this.props.selectSites(selected);
      this.props.onSitesUpdate(selected);
      cb();
    });
    (0, _defineProperty2.default)(this, "handleCancel", cb => () => {
      this.setSelectedSitesToState(new Set(this.props.selectedSites));
      cb();
    });
    this.state = {
      shouldFilter: false,
      selectedSites: new Set(),
      matchingProjects: new Set(),
      matchingSites: new Set(),
      isAllSelected: false,
      isPristine: true,
      sitesArray: Object.values(props.sites)
    };
  }

  componentDidMount() {
    this.setSelectedSitesToState(new Set(this.props.selectedSites));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedSites !== this.props.selectedSites) {
      this.setSelectedSitesToState(new Set(this.props.selectedSites));
    }

    if (prevProps.activeProject !== this.props.activeProject) {
      this.handleActiveProjectChange();
    }

    if (prevProps.sites !== this.props.sites) {
      this.setState({
        sitesArray: Object.values(this.props.sites)
      });
    }
  }

  setSelectedSitesToState(selectedSites) {
    const isAllSelected = (0, _utils.calcIsAllSelected)(this.props.activeProject.sites, selectedSites);
    this.setState({
      isAllSelected,
      selectedSites,
      isPristine: true
    });
  }

  render() {
    const {
      sites,
      projectGroups,
      activeProject,
      activeSite,
      selectProject,
      className,
      isLoading,
      hasLoaded,
      isMultiSite
    } = this.props;
    const {
      selectedSites,
      matchingSites,
      matchingProjects,
      shouldFilter,
      sitesArray
    } = this.state;
    const dataReady = hasLoaded && activeProject && activeProject.sites !== undefined;
    const menuLabel = isMultiSite && this.props.selectedSites.length > 1 ? /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "site_menu.label",
      values: {
        0: this.props.selectedSites.length
      }
    }) : activeSite.label;
    return /*#__PURE__*/_react2.default.createElement(_SiteMenu.MenuWrapper, {
      className: className
    }, /*#__PURE__*/_react2.default.createElement(_Menu.default, null, ({
      isOpen,
      toggle,
      close,
      menuRef
    }) =>
    /*#__PURE__*/

    /* TODO: Fix the type */
    _react2.default.createElement("div", {
      ref: menuRef
    }, dataReady && /*#__PURE__*/_react2.default.createElement(_SiteMenu.GlobalSite, {
      onClick: toggle,
      "data-cy": "SiteMenu"
    }, /*#__PURE__*/_react2.default.createElement(_SiteMenuAvatar.SiteMenuAvatar, {
      icon: /*#__PURE__*/_react2.default.createElement(IconSite, null)
    }), /*#__PURE__*/_react2.default.createElement(_SiteMenu.ActiveSite, {
      title: menuLabel
    }, menuLabel), /*#__PURE__*/_react2.default.createElement(_SiteMenu.Triangle, null)), /*#__PURE__*/_react2.default.createElement(_SiteMenu.MenuContainer, {
      isOpen: isOpen
    }, isLoading && /*#__PURE__*/_react2.default.createElement(_SiteMenu.LoadingContainer, null, /*#__PURE__*/_react2.default.createElement(_Loading.default, null)), dataReady && /*#__PURE__*/_react2.default.createElement(_react2.Fragment, null, /*#__PURE__*/_react2.default.createElement(_FilterList.default, {
      data: sitesArray,
      filterKey: "label",
      onChange: this.handleFilter
    }, ({
      inputRef,
      onChange
    }) =>
    /*#__PURE__*/

    /* TODO: Fix the type */
    _react2.default.createElement(_SiteMenu.SearchWrapper, null, /*#__PURE__*/_react2.default.createElement(_SiteMenu.Search, {
      noClear: true,
      inputRef: inputRef,
      onChange: onChange,
      placeholder: _core.i18n._({
        id: 'site_menu.filter_sites',
        message: `Filter sites`
      })
    }))), /*#__PURE__*/_react2.default.createElement(_SiteMenu.ColumnContainer, null, /*#__PURE__*/_react2.default.createElement("div", {
      className: "Column"
    }, /*#__PURE__*/_react2.default.createElement("div", {
      className: "MenuSection-header"
    }, /*#__PURE__*/_react2.default.createElement("h2", null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "site_menu.projects"
    }))), projectGroups && /*#__PURE__*/_react2.default.createElement("div", {
      className: "MenuSection-list"
    }, /*#__PURE__*/_react2.default.createElement(_Projects.default, {
      projects: projectGroups,
      matches: matchingProjects,
      onClick: selectProject,
      active: activeProject,
      shouldFilter: shouldFilter
    }))), /*#__PURE__*/_react2.default.createElement("div", {
      className: "Column"
    }, /*#__PURE__*/_react2.default.createElement("div", {
      className: "MenuSection-header"
    }, /*#__PURE__*/_react2.default.createElement("h2", null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "site_menu.sites",
      values: {
        0: activeProject.sites.length
      }
    })), /*#__PURE__*/_react2.default.createElement(_blocks.Checkbox, {
      checked: this.state.isAllSelected,
      onChange: this.handleSelectAll
    })), activeProject && /*#__PURE__*/_react2.default.createElement(_Sites.default, {
      sites: activeProject.sites,
      matches: matchingSites,
      selectedSites: selectedSites,
      onClick: this.handleSiteSelect,
      shouldFilter: shouldFilter
    })), /*#__PURE__*/_react2.default.createElement("div", {
      className: "Column"
    }, /*#__PURE__*/_react2.default.createElement("div", {
      className: "MenuSection-header"
    }, /*#__PURE__*/_react2.default.createElement("h2", null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "site_menu.selected",
      values: {
        0: selectedSites.size
      }
    })), /*#__PURE__*/_react2.default.createElement(_SiteMenu.Clear, {
      thin: true,
      appearance: "plain",
      onClick: this.handleClearAll
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "site_menu.clear_all"
    }))), /*#__PURE__*/_react2.default.createElement(_SelectedSites.SelectedSites, {
      sites: sites,
      selectedSites: selectedSites,
      handleClick: this.handleSiteSelect
    }))), /*#__PURE__*/_react2.default.createElement(_MenuFooter.default, {
      isConfirmDisabled: selectedSites.size < 1 || this.state.isPristine,
      isZeroSites: selectedSites.size < 1,
      onCancel: this.handleCancel(close),
      onConfirm: this.handleConfirmSelectedSites(close)
    }))))));
  }

}

exports.SiteMenu = SiteMenu;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SiteMenu);

exports.default = _default;